import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-309e58e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full max-w-2xl bg-[#141d27] border-l border-color shadow-2xl flex flex-col" }
const _hoisted_2 = { class: "flex items-start justify-between p-5 border-b border-color" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/profil-avatar-icon.svg",
  class: "w-14 h-14 rounded-full bg-gray-800 p-2"
}, null, -1))
const _hoisted_5 = { class: "text-white text-lg font-bold" }
const _hoisted_6 = { class: "text-gray-400 text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray-500 ml-2"
}
const _hoisted_8 = {
  key: 0,
  class: "text-gray-500 text-xs"
}
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Modifier", -1))
const _hoisted_11 = { class: "flex items-center border-b border-color px-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex-1 overflow-y-auto p-5" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-3 text-sm"
}
const _hoisted_15 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Téléphone", -1))
const _hoisted_17 = { class: "text-white" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Adresse", -1))
const _hoisted_19 = { class: "text-white" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Date de naissance", -1))
const _hoisted_21 = { class: "text-white" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Date d'embauche", -1))
const _hoisted_23 = { class: "text-white" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Situation familiale", -1))
const _hoisted_25 = { class: "text-white" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Enfants", -1))
const _hoisted_27 = { class: "text-white" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Salaire", -1))
const _hoisted_29 = { class: "text-green-400 font-semibold" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Pièce d'identité", -1))
const _hoisted_31 = { class: "text-white" }
const _hoisted_32 = {
  key: 0,
  class: "pt-3 border-t border-color"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs mb-1" }, "Informations bancaires", -1))
const _hoisted_34 = { class: "text-white" }
const _hoisted_35 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Nom", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Prénom", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Email", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Téléphone", -1))
const _hoisted_40 = { class: "col-span-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Adresse", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Date de naissance", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Date d'embauche", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Poste", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Situation familiale", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Pièce d'identité", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Enfants", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Salaire (FCFA)", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Matricule", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Banque", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "N° Compte", -1))
const _hoisted_52 = { class: "flex justify-end gap-2 pt-3 border-t border-color" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "flex items-center justify-between mb-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white font-semibold" }, "Contrat en cours", -1))
const _hoisted_58 = {
  key: 0,
  class: "border border-color rounded-lg p-4 mb-4 bg-gray-900/40"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300 text-sm mb-3" }, "Nouveau contrat", -1))
const _hoisted_60 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_61 = { class: "col-span-2" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Type de contrat *", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Date début *", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-xs mb-1" }, "Date fin (optionnelle)", -1))
const _hoisted_65 = { class: "flex justify-end gap-2 mt-3" }
const _hoisted_66 = {
  key: 1,
  class: "text-gray-500 text-center py-6 text-sm"
}
const _hoisted_67 = {
  key: 2,
  class: "text-gray-500 text-center py-6 text-sm"
}
const _hoisted_68 = {
  key: 3,
  class: "space-y-3"
}
const _hoisted_69 = { class: "flex items-start justify-between" }
const _hoisted_70 = { class: "text-white font-semibold" }
const _hoisted_71 = { class: "text-gray-400 text-xs mt-1" }
const _hoisted_72 = { class: "text-gray-200" }
const _hoisted_73 = { class: "text-gray-200" }
const _hoisted_74 = { class: "flex justify-end gap-2 mt-3 text-xs" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { key: 2 }
const _hoisted_78 = {
  key: 0,
  class: "text-gray-500 text-center py-6 text-sm"
}
const _hoisted_79 = {
  key: 1,
  class: "text-gray-500 text-center py-6 text-sm"
}
const _hoisted_80 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_81 = { class: "text-white text-sm" }
const _hoisted_82 = { class: "text-gray-500 text-xs" }
const _hoisted_83 = { key: 3 }
const _hoisted_84 = {
  key: 0,
  class: "text-gray-500 text-center py-6 text-sm"
}
const _hoisted_85 = {
  key: 1,
  class: "text-gray-500 text-center py-6 text-sm"
}
const _hoisted_86 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_87 = { class: "text-white text-sm" }
const _hoisted_88 = { class: "text-gray-500 text-xs" }
const _hoisted_89 = { class: "text-green-400 font-semibold text-sm" }

import api from "@/api";
	import { ref, watch, computed, onMounted } from "vue";
	import useNotyf from "@/composable/useNotyf";
	import rules from "@/rules";
	import { validateAll } from "@/validator";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'StaffDetailDrawer',
  props: {
    staff: {},
    editOnOpen: { type: Boolean }
  },
  emits: ["close", "changed"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Side drawer showing everything about one staff member: identity,
	 * contracts (CRUD), leaves history, bonuses history.
	 *
	 * Emits `close` when dismissed.
	 */
	const props = __props;
	const emit = __emit;

	const notify = useNotyf();
	const activeTab = ref<"identity" | "contracts" | "leaves" | "bonuses">("identity");
	const contracts = ref<any[]>([]);
	const leaves = ref<any[]>([]);
	const bonuses = ref<any[]>([]);
	const contractTypes = ref<{ key: number; value: string }[]>([]);
	const maritalStatusList = ref<{ key: number; value: string }[]>([]);
	const responsabilityList = ref<{ key: number; value: string }[]>([]);
	const identityCardList = ref<{ key: number; value: string }[]>([]);
	const isLoading = ref(false);
	const isSavingIdentity = ref(false);
	const showCreateContract = ref(false);
	const isEditingIdentity = ref(false);

	// Editable copy of identity fields. Hydrated on `enter edit mode`.
	const identityForm = ref<any>({
		name: "",
		last_name: "",
		email: "",
		phone: "",
		address: "",
		birth_date: "",
		hiring_date: "",
		nbr_children: 0,
		salary: 0,
		bank_name: "",
		account_number: "",
		matricule: "",
		marital_status_id: null as number | null,
		identity_type_card_id: null as number | null,
		responsability_function_id: null as number | null,
	});

	const contractForm = ref({
		personal_id: 0,
		contract_type_id: 0,
		payment_method_id: null as number | null,
		date_start: "",
		date_end: "",
	});

	// `value` must point at the inner reactive object (`contractForm.value`)
	// rather than the ref itself — `validateAll` calls `validator(value)`
	// expecting the unwrapped data. Returning a `computed` of refs would
	// hand the ref over and `v.contract_type_id` would be undefined.
	const contractValidations = computed(() => ({
		contract_type_id: {
			value: contractForm.value,
			validator: (v: any) => Number(v?.contract_type_id) > 0,
			msg: { error: "Type requis" },
		},
		date_start: {
			value: contractForm.value,
			validator: (v: any) => !!v?.date_start && rules.global.date.test(v.date_start),
			msg: { error: "Date début requise" },
		},
	}));

	const fmtDate = (d: string | null) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");
	const fmtMoney = (n: any) =>
		new Intl.NumberFormat("fr-FR").format(Math.round(parseFloat(n) || 0)) + " FCFA";

	const statusBadge = (s: string) => {
		switch (s) {
			case "active": return "bg-green-500/20 text-green-300 border border-green-500/30";
			case "ending_soon": return "bg-orange-500/20 text-orange-300 border border-orange-500/30";
			case "expired": return "bg-red-500/20 text-red-300 border border-red-500/30";
			default: return "bg-gray-500/20 text-gray-300 border border-gray-500/30";
		}
	};
	const statusLabel = (s: string) => ({
		active: "En cours", ending_soon: "Expire bientôt", expired: "Expiré",
	} as any)[s] || s;

	const loadContracts = async () => {
		if (!props.staff?.id) return;
		isLoading.value = true;
		try {
			const r: any = await api().contracts.getByPersonal(props.staff.id);
			contracts.value = Array.isArray(r.data) ? r.data : r.data?.data || [];
		} catch (err) { console.warn(err); }
		isLoading.value = false;
	};

	const loadContractTypes = async () => {
		try {
			const r: any = await api().contractTypes.getAll("");
			const items = Array.isArray(r.data) ? r.data : r.data?.data || [];
			contractTypes.value = items.map((t: any) => ({ key: t.id, value: t.label }));
		} catch (err) { console.warn(err); }
	};

	const loadLeaves = async () => {
		if (!props.staff?.id) return;
		isLoading.value = true;
		try {
			const r: any = await api().humanresource.leave.getAll();
			const all = Array.isArray(r.data) ? r.data : r.data?.data || [];
			leaves.value = all.filter((l: any) => l.personal?.id === props.staff.id || l.personal_id === props.staff.id);
		} catch (err) { console.warn(err); }
		isLoading.value = false;
	};

	const loadBonuses = async () => {
		if (!props.staff?.id) return;
		isLoading.value = true;
		try {
			const r: any = await api().humanresource.bonus.getAll();
			const all = Array.isArray(r.data) ? r.data : r.data?.data || [];
			bonuses.value = all.filter((b: any) => b.personal?.id === props.staff.id || b.personal_id === props.staff.id);
		} catch (err) { console.warn(err); }
		isLoading.value = false;
	};

	watch(() => activeTab.value, (tab) => {
		if (tab === "contracts" && contracts.value.length === 0) loadContracts();
		if (tab === "leaves" && leaves.value.length === 0) loadLeaves();
		if (tab === "bonuses" && bonuses.value.length === 0) loadBonuses();
	});

	const openCreateContract = () => {
		contractForm.value = {
			personal_id: props.staff.id,
			contract_type_id: 0,
			payment_method_id: null,
			date_start: new Date().toISOString().split("T")[0],
			date_end: "",
		};
		showCreateContract.value = true;
	};

	const submitContract = async () => {
		if (!validateAll(contractValidations.value)) {
			notify.warning("Champs obligatoires manquants");
			return;
		}
		try {
			const payload: any = { ...contractForm.value };
			if (!payload.date_end) delete payload.date_end;
			if (!payload.payment_method_id) delete payload.payment_method_id;
			await api().contracts.create(payload);
			notify.success("Contrat créé");
			showCreateContract.value = false;
			await loadContracts();
			emit("changed");
		} catch (err: any) {
			notify.error("Erreur : " + (err?.response?.data?.message || ""));
		}
	};

	const endContract = async (c: any) => {
		if (!confirm(`Terminer le contrat ? La date de fin sera définie à aujourd'hui.`)) return;
		try {
			await api().contracts.endContract(c.id, new Date().toISOString().split("T")[0]);
			notify.success("Contrat clôturé");
			await loadContracts();
			emit("changed");
		} catch { notify.error("Erreur"); }
	};

	const deleteContract = async (c: any) => {
		if (!confirm("Supprimer ce contrat ? Cette action est irréversible.")) return;
		try {
			await api().contracts.remove(c.id);
			notify.success("Contrat supprimé");
			await loadContracts();
			emit("changed");
		} catch { notify.error("Erreur"); }
	};

	const loadIdentityLookups = async () => {
		try {
			const [m, r, i] = await Promise.all([
				api().others.maritalStatus.getAll(),
				api().others.responsabilityFunction.getAll(),
				api().others.identityTypeCard.getAll(),
			]);
			maritalStatusList.value = (Array.isArray(m.data) ? m.data : m.data?.data || [])
				.map((x: any) => ({ key: x.id, value: x.label }));
			responsabilityList.value = (Array.isArray(r.data) ? r.data : r.data?.data || [])
				.map((x: any) => ({ key: x.id, value: x.label }));
			identityCardList.value = (Array.isArray(i.data) ? i.data : i.data?.data || [])
				.map((x: any) => ({ key: x.id, value: x.label }));
		} catch (err) { console.warn("[drawer] identity lookups load failed", err); }
	};

	const startEditIdentity = () => {
		identityForm.value = {
			name: props.staff.name || "",
			last_name: props.staff.last_name || "",
			email: props.staff.email || "",
			phone: props.staff.phone || "",
			address: props.staff.address || "",
			birth_date: props.staff.birth_date || "",
			hiring_date: props.staff.hiring_date || "",
			nbr_children: props.staff.nbr_children ?? 0,
			salary: props.staff.salary ?? 0,
			bank_name: props.staff.bank_name || "",
			account_number: props.staff.account_number || "",
			matricule: props.staff.matricule || "",
			marital_status_id: props.staff.marital_status?.id ?? null,
			identity_type_card_id: props.staff.identity_type_card?.id ?? null,
			responsability_function_id: props.staff.responsability_functions?.id ?? null,
		};
		isEditingIdentity.value = true;
	};

	const cancelEditIdentity = () => {
		isEditingIdentity.value = false;
	};

	const submitEditIdentity = async () => {
		if (!props.staff?.id) return;
		isSavingIdentity.value = true;
		try {
			// Strip empty / null values so the backend's "ignore null"
			// merge in PersonalRepository::update doesn't reset fields the
			// user didn't touch.
			const payload: any = {};
			Object.entries(identityForm.value).forEach(([k, v]) => {
				if (v !== "" && v !== null && v !== undefined) payload[k] = v;
			});
			const r: any = await api().stations.users.personal.edit(props.staff.id, payload);
			notify.success("Personnel mis à jour");
			isEditingIdentity.value = false;
			// Mutate the prop reference so the read-only view picks the new
			// values without refetch. The parent list will refresh on close.
			Object.assign(props.staff, payload);
			emit("changed");
		} catch (err: any) {
			notify.error("Erreur : " + (err?.response?.data?.message || err?.data?.message || ""));
			console.warn(err);
		} finally {
			isSavingIdentity.value = false;
		}
	};

	onMounted(async () => {
		await Promise.all([loadContractTypes(), loadIdentityLookups()]);
		// Pre-fetch contracts since it's the most actionable tab
		await loadContracts();
		// If the drawer was opened from a row's "Modifier" button, jump
		// straight into edit mode on the Identity tab.
		if (props.editOnOpen) {
			activeTab.value = "identity";
			startEditIdentity();
		}
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fixed inset-0 z-40 flex",
    onKeydown: _cache[21] || (_cache[21] = _withKeys(($event: any) => (emit('close')), ["esc"]))
  }, [
    _createElementVNode("div", {
      class: "flex-1 bg-black/50",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.staff.name) + " " + _toDisplayString(_ctx.staff.last_name), 1),
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.staff.responsability_functions?.label || "—") + " ", 1),
              (_ctx.staff.matricule)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "#" + _toDisplayString(_ctx.staff.matricule), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.staff.email)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.staff.email), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (activeTab.value === 'identity' && !isEditingIdentity.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "flex items-center gap-2 text-xs bg-[#219152] hover:bg-[#167841] text-white px-3 py-2 rounded font-medium",
                onClick: startEditIdentity
              }, [
                _createVNode(_component_Icon, {
                  src: "/media/icons/edit-icon.svg",
                  css: "w-4 h-4"
                }),
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "text-gray-400 hover:text-white text-2xl leading-none px-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
            "aria-label": "Fermer"
          }, "×")
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
						{ key: 'identity', label: 'Identité' },
						{ key: 'contracts', label: 'Contrats' },
						{ key: 'leaves', label: 'Congés' },
						{ key: 'bonuses', label: 'Primes' },
					], (t) => {
          return _createElementVNode("button", {
            key: t.key,
            class: _normalizeClass(["px-4 py-3 text-sm", activeTab.value === t.key ? 'text-accent border-b-2 border-accent' : 'text-gray-400 hover:text-white']),
            onClick: ($event: any) => (activeTab.value = t.key as any)
          }, _toDisplayString(t.label), 11, _hoisted_12)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_13, [
        (activeTab.value === 'identity')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (!isEditingIdentity.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", null, [
                        _hoisted_16,
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.staff.phone || '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_18,
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.staff.address || '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_20,
                        _createElementVNode("p", _hoisted_21, _toDisplayString(fmtDate(_ctx.staff.birth_date)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_22,
                        _createElementVNode("p", _hoisted_23, _toDisplayString(fmtDate(_ctx.staff.hiring_date)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_24,
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.staff.marital_status?.label || '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.staff.nbr_children ?? '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.staff.salary ? fmtMoney(_ctx.staff.salary) : '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_30,
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.staff.identity_type_card?.label || '—'), 1)
                      ])
                    ]),
                    (_ctx.staff.bank_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.staff.bank_name) + " — " + _toDisplayString(_ctx.staff.account_number || '—'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", null, [
                        _hoisted_36,
                        _createVNode(_component_InputTag, {
                          type: "text",
                          value: identityForm.value.name,
                          onModel: _cache[2] || (_cache[2] = (e) => identityForm.value.name = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_37,
                        _createVNode(_component_InputTag, {
                          type: "text",
                          value: identityForm.value.last_name,
                          onModel: _cache[3] || (_cache[3] = (e) => identityForm.value.last_name = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_38,
                        _createVNode(_component_InputTag, {
                          type: "email",
                          value: identityForm.value.email,
                          onModel: _cache[4] || (_cache[4] = (e) => identityForm.value.email = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_39,
                        _createVNode(_component_InputTag, {
                          type: "tel",
                          value: identityForm.value.phone,
                          onModel: _cache[5] || (_cache[5] = (e) => identityForm.value.phone = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createVNode(_component_InputTag, {
                          type: "text",
                          value: identityForm.value.address,
                          onModel: _cache[6] || (_cache[6] = (e) => identityForm.value.address = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_42,
                        _createVNode(_component_InputTag, {
                          type: "date",
                          value: identityForm.value.birth_date,
                          onModel: _cache[7] || (_cache[7] = (e) => identityForm.value.birth_date = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_43,
                        _createVNode(_component_InputTag, {
                          type: "date",
                          value: identityForm.value.hiring_date,
                          onModel: _cache[8] || (_cache[8] = (e) => identityForm.value.hiring_date = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_44,
                        _createVNode(_component_SelectTag, {
                          placeholder: "—",
                          data: JSON.stringify(responsabilityList.value),
                          selected: String(identityForm.value.responsability_function_id ?? ''),
                          onModel: _cache[9] || (_cache[9] = (e) => identityForm.value.responsability_function_id = e.key)
                        }, null, 8, ["data", "selected"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_45,
                        _createVNode(_component_SelectTag, {
                          placeholder: "—",
                          data: JSON.stringify(maritalStatusList.value),
                          selected: String(identityForm.value.marital_status_id ?? ''),
                          onModel: _cache[10] || (_cache[10] = (e) => identityForm.value.marital_status_id = e.key)
                        }, null, 8, ["data", "selected"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_46,
                        _createVNode(_component_SelectTag, {
                          placeholder: "—",
                          data: JSON.stringify(identityCardList.value),
                          selected: String(identityForm.value.identity_type_card_id ?? ''),
                          onModel: _cache[11] || (_cache[11] = (e) => identityForm.value.identity_type_card_id = e.key)
                        }, null, 8, ["data", "selected"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_47,
                        _createVNode(_component_InputTag, {
                          type: "number",
                          min: 0,
                          max: 20,
                          value: identityForm.value.nbr_children,
                          onModel: _cache[12] || (_cache[12] = (e) => identityForm.value.nbr_children = Number(e))
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_48,
                        _createVNode(_component_InputTag, {
                          type: "number",
                          min: 0,
                          value: identityForm.value.salary,
                          onModel: _cache[13] || (_cache[13] = (e) => identityForm.value.salary = Number(e))
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_49,
                        _createVNode(_component_InputTag, {
                          type: "text",
                          value: identityForm.value.matricule,
                          onModel: _cache[14] || (_cache[14] = (e) => identityForm.value.matricule = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_50,
                        _createVNode(_component_InputTag, {
                          type: "text",
                          value: identityForm.value.bank_name,
                          onModel: _cache[15] || (_cache[15] = (e) => identityForm.value.bank_name = e)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_51,
                        _createVNode(_component_InputTag, {
                          type: "text",
                          value: identityForm.value.account_number,
                          onModel: _cache[16] || (_cache[16] = (e) => identityForm.value.account_number = e)
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("button", {
                        class: "text-xs text-gray-400 hover:text-white px-3 py-1.5",
                        disabled: isSavingIdentity.value,
                        onClick: cancelEditIdentity
                      }, "Annuler", 8, _hoisted_53),
                      _createElementVNode("button", {
                        class: "text-xs bg-[#219152] hover:bg-[#167841] text-white px-3 py-1.5 rounded disabled:opacity-50",
                        disabled: isSavingIdentity.value,
                        onClick: submitEditIdentity
                      }, _toDisplayString(isSavingIdentity.value ? 'Enregistrement…' : 'Enregistrer'), 9, _hoisted_54)
                    ])
                  ], 64))
            ]))
          : (activeTab.value === 'contracts')
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  (!showCreateContract.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-xs bg-[#219152] text-white px-3 py-1.5 rounded hover:bg-[#167841]",
                        onClick: openCreateContract
                      }, "+ Nouveau contrat"))
                    : _createCommentVNode("", true)
                ]),
                (showCreateContract.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createVNode(_component_SelectTag, {
                            placeholder: "CDI / CDD / stage...",
                            onModel: _cache[17] || (_cache[17] = (e) => contractForm.value.contract_type_id = e.key),
                            data: JSON.stringify(contractTypes.value)
                          }, null, 8, ["data"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_63,
                          _createVNode(_component_InputTag, {
                            type: "date",
                            onModel: _cache[18] || (_cache[18] = (e) => contractForm.value.date_start = e),
                            value: contractForm.value.date_start
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_64,
                          _createVNode(_component_InputTag, {
                            type: "date",
                            onModel: _cache[19] || (_cache[19] = (e) => contractForm.value.date_end = e),
                            value: contractForm.value.date_end
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("button", {
                          class: "text-xs text-gray-400 px-3 py-1.5",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (showCreateContract.value = false))
                        }, "Annuler"),
                        _createElementVNode("button", {
                          class: "text-xs bg-[#219152] text-white px-3 py-1.5 rounded hover:bg-[#167841]",
                          onClick: submitContract
                        }, "Créer")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Chargement…"))
                  : (contracts.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Aucun contrat enregistré "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contracts.value, (c) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: c.id,
                            class: "border border-color rounded-lg p-4 bg-gray-900/40"
                          }, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_70, _toDisplayString(c.contract_type?.label || '—'), 1),
                                _createElementVNode("p", _hoisted_71, [
                                  _createTextVNode(" Du "),
                                  _createElementVNode("span", _hoisted_72, _toDisplayString(fmtDate(c.date_start)), 1),
                                  _createTextVNode(" au "),
                                  _createElementVNode("span", _hoisted_73, _toDisplayString(c.date_end ? fmtDate(c.date_end) : 'indéterminé'), 1)
                                ])
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["text-xs px-2 py-0.5 rounded", statusBadge(c.status)])
                              }, _toDisplayString(statusLabel(c.status)), 3)
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              (c.status === 'active')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "text-orange-300 hover:text-orange-200",
                                    onClick: ($event: any) => (endContract(c))
                                  }, "Clôturer", 8, _hoisted_75))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "text-red-400 hover:text-red-300",
                                onClick: ($event: any) => (deleteContract(c))
                              }, "Supprimer", 8, _hoisted_76)
                            ])
                          ]))
                        }), 128))
                      ]))
              ]))
            : (activeTab.value === 'leaves')
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, "Chargement…"))
                    : (leaves.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, "Aucun congé"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leaves.value, (l) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: l.id,
                              class: "border border-color rounded-lg p-3 bg-gray-900/40 flex items-center justify-between"
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_81, _toDisplayString(l.leave_type || l.type || '—'), 1),
                                _createElementVNode("p", _hoisted_82, _toDisplayString(fmtDate(l.start_date || l.date_start)) + " → " + _toDisplayString(fmtDate(l.end_date || l.date_end)), 1)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["text-xs px-2 py-0.5 rounded", {
									'bg-green-500/20 text-green-300': l.status === 'approved',
									'bg-red-500/20 text-red-300': l.status === 'rejected',
									'bg-orange-500/20 text-orange-300': l.status === 'pending' || !l.status,
								}])
                              }, _toDisplayString(l.status || 'pending'), 3)
                            ]))
                          }), 128))
                        ]))
                ]))
              : (activeTab.value === 'bonuses')
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, "Chargement…"))
                      : (bonuses.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, "Aucune prime"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonuses.value, (b) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: b.id,
                                class: "border border-color rounded-lg p-3 bg-gray-900/40 flex items-center justify-between"
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_87, _toDisplayString(b.bonus_type || '—'), 1),
                                  _createElementVNode("p", _hoisted_88, _toDisplayString(fmtDate(b.date)) + " — " + _toDisplayString(b.reason || ''), 1)
                                ]),
                                _createElementVNode("span", _hoisted_89, _toDisplayString(fmtMoney(b.amount)), 1)
                              ]))
                            }), 128))
                          ]))
                  ]))
                : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}
}

})